// Tells image-shaped URLs apart from video-shaped URLs. The availability_bot
// stuffs both into the same `images[]` jsonb column on `projects` — when a
// project has only a video uploaded, the hero would otherwise render a broken
// <img> tag pointed at an .mp4. Callers use this to render <video> tiles
// instead.
const VIDEO_EXT_RE = /\.(mp4|webm|mov|m4v|ogv)(\?|#|$)/i;

export const isVideoUrl = (url: string | null | undefined): boolean => {
  if (!url || typeof url !== 'string') return false;
  return VIDEO_EXT_RE.test(url);
};

export const isImageUrl = (url: string | null | undefined): boolean => {
  if (!url || typeof url !== 'string') return false;
  return !isVideoUrl(url);
};
